import React from 'react'
import styled from 'styled-components'

import appStoreBadge from '@assets/app-store-badge.svg'
import googlePlayBadge from '@assets/google-play-badge.svg'
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links'

const Container = styled.div`
  display: flex;
  gap: 16px;

  a {
    display: block;
  }

  img {
    display: block;
    height: 40px;
    width: auto;
  }
`

type DownloadCreatorAppProps = {
  analytics?: string
}

export const DownloadCreatorApp = ({ analytics }: DownloadCreatorAppProps) => (
  <Container data-analytics={analytics}>
    <div>
      <a href={MOBILE_APP_IOS_LINK} target="_blank" rel="noreferrer">
        <img src={appStoreBadge} alt="App Store Badge" />
      </a>
    </div>
    <div>
      <a href={MOBILE_APP_ANDROID_LINK} target="_blank" rel="noreferrer">
        <img src={googlePlayBadge} alt="Google Play Badge" />
      </a>
    </div>
  </Container>
)
